import React, { useEffect, useState } from "react";
import health from "../Images/Health-Home.png";
import bike from "../Images/Bike.svg";
import commercial from "../Images/commercial.svg";
import travel from "../Images/plane.png";
import loan from "../Images/Loan.svg";
import { Link } from "react-router-dom";
import car from "../Images/car.svg";
import { getVehicleMaster } from "../../Redux/Action";
import { GetDataLocalStorage, carReqObj, AddToLocalStorage } from "../GlobalObj";
import { useDispatch, useSelector } from "react-redux";
import "../Pages/Main.css";
import RoadBike from "../../Vehicle/Images/Bike-Page/BikeGif.gif";
import RoadImg from "../../Vehicle/Images/commercial-page/truckwithbuilding.gif";
import roadCar from "../../Vehicle/Images/Car-Page/carwithbuilding.gif";
import TestiMonials from "../Pages/TestiMonials/TestiMonials";
import RegistrationNumberFetching from "../../Vehicle/Components/RegistrationNumberFetching/RegistrationNumberFetching";
import ContactUs from "../../Framework/Pages/ContactUs";
import {
  Box,
  CardMedia,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import Grow from "@mui/material/Grow";
import Slide from "@mui/material/Slide";
import {
  ourRecords,
  testimonials,
  ourpartners,
  contact,
} from "../Utils/maincontent";
import icicilombardlogo from "../Images/Group 1icicilombard.svg";
import hdfclogo from "../Images/Group 13hdfcergo.svg";
import bajajAlianzlogo from "../Images/Group 12bajaj alianz.svg";
import carehealthlogo from "../Images/Group 2care.svg";
import sbilifelogo from "../Images/Group 6sbilife.svg";
import godigitlogo from "../Images/Group 4godigit.svg";
import pnblogo from "../Images/Group 11pnbmetlife.svg";
import iciciprudentiallogo from "../Images/Group 3iciciprud.svg";
import bharathiAxalogo from "../Images/Group 10bharathgiAxa.svg";
import starinsurancelogo from "../Images/Group 8starinsurancee.svg";
import tataAialogo from "../Images/Group 9Tata Aia.svg";
import royalSundaramlogo from "../Images/Group 5royalsundaram.svg";
import OurRecords from "./OurRecords/OurRecords";
import axios from "axios";

import total from "../Images/Vector Smart Object2-01 1.svg";
import Insured from "../Images/Vector Smart Object3-01 1.svg";
import TotalInsurance from "../Images/Vector Smart Object5-01 1.svg";
import pos from "../Images/Vector Smart Object4-01 1.svg";
const { title } = ourRecords;

const partnerLogoUrl = [icicilombardlogo, hdfclogo, bajajAlianzlogo, carehealthlogo, sbilifelogo, godigitlogo, pnblogo, iciciprudentiallogo, bharathiAxalogo, starinsurancelogo, tataAialogo, royalSundaramlogo]

const Main = () => {
  const theme = useTheme();
  const { isLandingPageTrue } = useSelector((state) => state?.auth);
  const vehicleData = useSelector((state) => state?.motorReducer?.vehicleData);

  const [req, setReq] = useState(carReqObj);
  const [activeCards, setActiveCards] = useState({
    "Pvt Car": false,
    "MotorBike": false,
    "Goods Carrying": false,
  });
  const [imageSrc, setImageSrc] = useState(roadCar);
  const [, setReqs] = useState({});
  const dispatch = useDispatch();

  //Mui States for modal
  const [ourRecords, setOurRecords] = useState([])
  const [isLoadingTrue, setIsLoadingTrue] = useState(true)

  // const customerData = useSelector((store) => store.motorReducer.customerData); //customerdata

  useEffect(() => {
    dispatch({ type: "ISLANDINGPAGETRUE", payload: true });
    if (Object.keys(vehicleData || {})?.length > 0) {
      dispatch({ type: "clear_Vehicle_data" });
    }
    // let ncbData = GetDataLocalStorage("NcbData");
    // let insurenceName = GetDataLocalStorage("InsurenceCompanyName");
    // // let vehicleMaster = GetDataLocalStorage("vehicleMasterData");
    // let cityData = GetDataLocalStorage("cityData");
    // let pincode = GetDataLocalStorage("pincodeData");
    // let relation = GetDataLocalStorage("relationData");
    // // dispatch(getMarketingData());
    // ncbData ? dispatch(NCBSuccessRequest(ncbData)) : dispatch(getNCBValue());
    // insurenceName
    //   ? dispatch(InsurerNamesSuccessRequest(insurenceName))
    //   : dispatch(getInsurerName());
    // cityData ? dispatch(citySuccessRequest(cityData)) : dispatch(getCityData());
    // pincode
    //   ? dispatch(getSuccessPincode(pincode))
    //   : dispatch(getCityStateWithPincode());
    // relation
    //   ? dispatch(RelationSuccessRequest(relation))
    //   : dispatch(getRelations());
  }, [dispatch, vehicleData]);

  const callOurRecordsApi = async () => {
    try {
      setIsLoadingTrue(true)
      const response = await axios.get('https://5il6my5wxc.execute-api.ap-south-1.amazonaws.com/Prod/landingpagedata')
      if (response?.status === 200) {

        const mappedObject = [
          {
            logo: total,
            title: "Total Policy Sold",
            value: response?.data[0]?.policyCount?.count,
          },
          {
            logo: pos,
            title: "Total Posp Partners",
            value: response?.data[0]?.agentCount?.count,
          },
          {
            logo: Insured,
            title: "Total Insured Customers",
            value: response?.data[0]?.policyCount?.count,
          },
          {
            logo: TotalInsurance,
            title: "Total Insured Amount",
            value: response?.data[0]?.policyCount?.sum,
          },
        ];

        setOurRecords(mappedObject);
      }

    } catch (e) {
      console.log(e.message, 'error')
    } finally {
      setIsLoadingTrue(false)
    }
  }



  const handleClick = (value) => {
    // setIsLandingPageTrue(false)
    dispatch({ type: "ISLANDINGPAGETRUE", payload: false });
    const updatedActiveCards = { ...activeCards };
    for (const cardType in updatedActiveCards) {
      updatedActiveCards[cardType] = cardType === value;
    }

    setActiveCards(updatedActiveCards);
    let obj = { ...req };
    if (value === "Pvt Car") {
      setImageSrc(roadCar);
      obj.vehicle.vehicleType = "Car";
      obj.profile.customer.policyType = "Pvt Car";
      AddToLocalStorage("globalObj", obj);
      setReq(obj);
      dispatch(getVehicleMaster(value));
      //  navigate('/motor/car');
    } else if (value === "MotorBike") {
      setImageSrc(RoadBike);
      obj.vehicle.vehicleType = "Bike";
      obj.profile.customer.policyType = "MotorBike";
      AddToLocalStorage("globalObj", obj);
      setReq(obj);
      dispatch(getVehicleMaster(value));
      // navigate('/motor/bike');
    } else if (value === "Goods Carrying") {
      setImageSrc(RoadImg);
      obj.vehicle.vehicleType = "Commercial";
      obj.profile.customer.policyType = "Goods Carrying";
      AddToLocalStorage("globalObj", obj);
      setReq(obj);
      dispatch(getVehicleMaster("Goods Carrying"));
      // navigate('/motor/commercial');
    }
  };

  useEffect(() => {
    callOurRecordsApi()
    let obj = GetDataLocalStorage("globalObj");
    if (obj) {
      setReqs(obj);
    } else {
      setReqs(carReqObj);
    }
  }, []);



  const Title = ({ variant = "h6", sx = {}, children, ...props }) => {
    const _component =
      typeof variant !== "object"
        ? variant
        : variant.xl ||
        variant.lg ||
        variant.md ||
        variant.sm ||
        variant.xs ||
        "h6";

    const _variantStyles =
      typeof variant !== "object"
        ? variant
        : {
          xs: variant.xs,
          sm: variant.sm || variant.xs,
          md: variant.md || variant.sm || variant.xs,
          lg: variant.lg || variant.md || variant.sm || variant.xs,
          xl:
            variant.xl ||
            variant.lg ||
            variant.md ||
            variant.sm ||
            variant.xs,
        };

    return (
      <Typography
        // variant={variant}
        sx={{
          ...sx,
          typography: typeof _variantStyles === "object" && _variantStyles,
          fontWeight: `${sx.fontWeight || 600}!important`,
        }}
        component={_component}
        {...props}
      >
        {children}
      </Typography>
    );
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            zIndex: -1,
            top: 0,
            left: 0,
            right: 0,
          }}
        >
          <Box sx={{
            background: "linear-gradient(180deg, #fff, rgba(60, 177, 249, 0.55) 100%)",
            height: "100dvh",
          }} />
          <CardMedia
            sx={{
              position: "absolute",
              width: "100%",
              right: 0,
              left: 0,
              bottom: 0
            }}
            component="img"
            image={imageSrc}
            alt="Paella dish"
          />
        </Box>
        {/* Modal for all the products */}
        <Container maxWidth="lg">
          <Grid container spacing={2} mt={1} flexGrow={1}>

            {/* car */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={200}>
                <div
                  className={`addition-service-card ${activeCards["Pvt Car"] ? "active" : ""
                    }`}
                  onClick={() => handleClick("Pvt Car")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="addition-service-card-img">
                    <img src={car} alt="" />
                  </div>
                  <div className="addition-service-card-title">Car</div>
                </div>
              </Grow>
            </Grid>

            {/* bike */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={300}>
                <div
                  className={`addition-service-card ${activeCards["MotorBike"] ? "active" : ""
                    }`}
                  onClick={() => handleClick("MotorBike")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="addition-service-card-img">
                    <img src={bike} alt="" />
                  </div>
                  <div className="addition-service-card-title">Bike</div>
                </div>
              </Grow>
            </Grid>

            {/* goods carrying */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={400}>
                <div
                  className={`addition-service-card ${activeCards["Goods Carrying"] ? "active" : ""
                    }`}
                  onClick={() => handleClick("Goods Carrying")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="addition-service-card-img">
                    <img src={commercial} alt="" />
                  </div>
                  <div className="addition-service-card-title">Commercial</div>
                </div>
              </Grow>
            </Grid>

            {/* health */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={500}>
                <Box component={Link} to='/health'
                  className="addition-service-card"
                  style={{ cursor: "pointer" }}

                >
                  <div className="addition-service-card-img">
                    <img src={health} alt="" />
                  </div>
                  <div className="addition-service-card-title">Health </div>
                  {/* <div className="tooltip">Coming Soon</div> */}
                </Box>
              </Grow>
            </Grid>

            {/* travel */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={600}>
                <div
                  className="addition-service-card travel-disabled"
                  style={{ cursor: "pointer" }}
                >
                  <div className="addition-service-card-img">
                    <img src={travel} alt="" />
                  </div>
                  <div className="addition-service-card-title">Travel </div>
                  <div className="coming-soon-overlay">This product is currently under internal testing (UAT) and will be available soon.</div>
                </div>
              </Grow>
            </Grid>

            {/* loan */}
            <Grid item xs={4} sm={3} md={3} lg={2}>
              <Grow in={true} timeout={700}>
                <Box component={Link} to="/loan"
                  className="addition-service-card"
                  style={{ cursor: "pointer" }}
                >
                  <div className="addition-service-card-img">
                    <img src={loan} alt="loan" />
                  </div>
                  <div className="addition-service-card-title">Loan </div>
                  {/* <div className="tooltip">Coming Soon</div> */}
                </Box>
              </Grow>
            </Grid>
          </Grid>
        </Container>

        <Slide
          direction="up"
          in={true}
          mountOnEnter
          unmountOnExit
          timeout={400}
        >
          <Container
            maxWidth="sm"
            sx={{
              height: "60vh",
              mt: 8,
              [theme.breakpoints.up("md")]: { mt: 5 },
              [theme.breakpoints.up("xs")]: { mt: 1 },
              // border: "solid"
            }}
          >
            <div className="fetching-section">
              {!isLandingPageTrue && (
                <RegistrationNumberFetching req={req} setreq={setReq} />
              )}
            </div>
          </Container>
        </Slide>
      </Box>

      {/* our records */}
      <Container sx={{ mt: { xs: 5, md: 10 } }}>
        <Container maxWidth="md">
          <Title
            variant={{ xs: "h4", md: "h3" }}
            sx={{ textAlign: "center" }}
          >
            {title}
          </Title>
        </Container>

        <Grid container spacing={3} sx={{ mt: 2 }} justifyContent="center">
          {isLoadingTrue ? (
            [0, 1, 2, 3].map((eachValue, index) => (
              <OurRecords key={index} loader={isLoadingTrue} />
            ))
          ) : (
            ourRecords.map(({ title, logo, value }, index) => (
              <OurRecords title={title} logo={logo} value={value} key={index} />
            )))}
        </Grid>
      </Container>

      {/* testimonials */}
      <Container sx={{ mt: { xs: 10, md: 10 } }}>
        <Container maxWidth="md">
          <Title
            variant={{ xs: "h4", md: "h3" }}
            sx={{ textAlign: "center" }}
          >
            {testimonials.title}
          </Title>
        </Container>

        <Grid container spacing={2} sx={{ mt: 3 }} justifyContent="center">
          <Grid item xs={12}>
            <TestiMonials />
          </Grid>
        </Grid>
      </Container>

      {/* our partners */}
      <Container sx={{ mt: { xs: 10, md: 10 } }}>
        <Container maxWidth="md">
          <Title
            variant={{ xs: "h4", md: "h3" }}
            sx={{ textAlign: "center" }}
          >
            {ourpartners.title}
          </Title>
        </Container>

        <Grid container spacing={7} sx={{ mt: 3 }} justifyContent="center">
          {
            partnerLogoUrl.map((partnerLogo) => {
              return <Grid item xs={6} sm={4} md={3} lg={2}>
                <img src={partnerLogo} alt="" className="partnerlogo" />
              </Grid>
            })
          }
        </Grid>
      </Container>

      {/* contact us */}
      <div
        style={{
          backgroundColor: "#dcdcdc",
          marginBottom: 2,
          padding: "20px 0",
        }}
        id="contact"
      >
        <Container>
          <Container maxWidth="md">
            <Title
              variant={{ xs: "h4", md: "h3" }}
              sx={{ textAlign: "center" }}
            >
              {contact.title}
            </Title>
          </Container>
          <Grid container spacing={2} sx={{ mt: 3 }} justifyContent="center">
            <ContactUs />
          </Grid>
        </Container>
      </div>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "450px",
          margin: "0 auto",
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7613.412674863406!2d78.44245937771!3d17.42587510000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97354cf31cef%3A0x43dfcea055a17fcf!2sIDFC%20AMC!5e0!3m2!1sen!2sin!4v1733982279718!5m2!1sen!2sin"
          style={{
            border: "0",
            width: "100%",
            height: "100%",
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="map"
        ></iframe>

        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "30%",
            height: "50px",
            background: "rgb(255, 255, 255)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: "1",
          }}
        >
          LMV INSURANCE SERVICES
          <br />
          Door No 6-3-354, 1st Floor, SB Tower, Road No 1, Near Punjagutta
          Circle, Hyderabad - 500082
        </div>
      </div>
    </>
  );
};

export default Main;
